import { ProductPriceWithName } from "../../../../../state/product-price/types"

export const ADD_PRICE = "add-price"
type ADD_PRICE = typeof ADD_PRICE

export const REMOVE_PRICE = "remove-price"
type REMOVE_PRICE = typeof REMOVE_PRICE

export const HANDLE_PRICE_CHANGE = "handle-price-change"
type HANDLE_PRICE_CHANGE = typeof HANDLE_PRICE_CHANGE

export const INITIALIZE_DISPLAYED_VALUES = "init-displayed-values"
type INITIALIZE_DISPLAYED_VALUES = typeof INITIALIZE_DISPLAYED_VALUES


export type UpdatePayload = {
    priceLevelId: string
}

export type HandlePriceChangePayload = UpdatePayload & {newPrice: number}

export type initializePayload = {
    displayedProductPrices: Map<string, ProductPriceWithName>
}

export type ProductPricePriceChangePayload = {
    priceLevelId: string,
    newPrice: number, 
}

export type Action = 
 | {type: ADD_PRICE, payload: UpdatePayload}
 | {type: REMOVE_PRICE, payload: UpdatePayload}
 | {type: HANDLE_PRICE_CHANGE, payload: HandlePriceChangePayload}
 | {type: INITIALIZE_DISPLAYED_VALUES, payload: initializePayload}

export const initialize = (displayedProductPrices: Map<string, ProductPriceWithName>) => {
    return <Action>{ type: INITIALIZE_DISPLAYED_VALUES, payload: { displayedProductPrices: displayedProductPrices } } 
}

export const addPrice = (priceLevelId: string) => {
    return <Action>{ type: ADD_PRICE, payload: { priceLevelId } } 
}

export const removePrice = (priceLevelId: string) => {
    return <Action>{ type: REMOVE_PRICE, payload: { priceLevelId } } 
}

export const handlePriceChange = (priceLevelId: string, newPrice: number) => {
    return <Action>{ type: HANDLE_PRICE_CHANGE, payload: { priceLevelId, newPrice } } 
}


// WEBPACK FOOTER //
// ./src/product/form/components/states/actions/productPriceActions.ts